var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"fill":"#CCC","d":"M19,6.4L17.6,5L12,10.6L6.4,5L5,6.4l5.6,5.6L5,17.6L6.4,19l5.6-5.6l5.6,5.6l1.4-1.4L13.4,12L19,6.4z","key":1})]);
}

Close.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Close;

Close.default = Close;
